
export enum EventCategory {
  Other = 'OTHER',
  Theater = 'THEATER',
  Comedy = 'COMEDY',
  Concert = 'CONCERT',
  Festival = 'FESTIVAL',
  Party = 'PARTY',
  PerformanceEvening = 'PERFORMANCE_EVENING',
  Sport = 'SPORT',
  Performance = 'PERFORMANCE',
  Gastro = 'GASTRO',
  Cinema = 'CINEMA',
  FolkDancePerformance = 'FOLK_DANCE_PERFORMANCE',
  DanceTheatre = 'DANCE_THEATRE',
  PerformanceShow = 'PERFORMANCE_SHOW',
}
